define([
    "../../hereMapsModule",
], function (hereMapsModule) {
    "use strict";

    return hereMapsModule.directive("carrierZoneHereMaps", [
        "carrierZoneDrawingService",
        "carrierZoneFreehandDrawingService",
        "carrierDrawingCommonService",
        "hereMapsService",
        function (carrierZoneDrawingService, carrierZoneFreehandDrawingService, carrierDrawingCommonService, hereMapsService) {
            return {
                restrict: "E",
                template: "<here-maps maps='here.maps' polygons-data='here.polygonsData'></here-maps>",
                scope: {
                    polygons: "=",
                    onRegisterApi: "=",
                },
                controller: ["$scope",
                    function ($scope) {

                        var polygonsHereApi = null;
                        $scope.onRegisterHereApi = function (api) {
                            polygonsHereApi = api;
                            $scope.onRegisterApi({
                                    getPolygons: polygonsHereApi.getPolygons,
                                    addPolygons: polygonsHereApi.addPolygons,
                                    centerMapOnPolygon: polygonsHereApi.centerMapOnPolygon
                                }
                            );
                        };

                        $scope.here = {
                            maps: {
                                hasFullScreen: true,
                                multiplesModes: true,
                                possibleModes: {
                                    navigate: true,
                                    hasDrawing: true
                                }
                            },
                            polygonsData: {
                                polygons: $scope.polygons,
                                onRegisterApi: $scope.onRegisterHereApi
                            }
                        };

                        $scope.$watch("here.maps.mode", function () {
                            if ($scope.here.maps.mode === "drawing") {
                                carrierZoneFreehandDrawingService.cancelDrawing();
                                carrierZoneDrawingService.startDrawing(function (polygons) {
                                    polygonsHereApi.addPolygons({
                                        polygons: polygons,
                                    });
                                });
                            }

                            if ($scope.here.maps.mode === "freehandDrawing") {
                                carrierZoneDrawingService.cancelDrawing();
                                carrierZoneFreehandDrawingService.startDrawing(function (polygons) {
                                    polygonsHereApi.addPolygons({
                                        polygons: polygons,
                                    });
                                });
                            }

                            if ($scope.here.maps.mode === "navigate") {
                                carrierZoneDrawingService.cancelDrawing();
                                carrierZoneFreehandDrawingService.cancelDrawing();
                                if (hereMapsService.getBehavior() ){
                                    hereMapsService.getBehavior().enable(
                                        hereMapsService.getHere().mapevents.Behavior.Feature.PANNING
                                    );
                                    carrierDrawingCommonService.setCursor(false);
                                }
                            }

                        });

                        $scope.$on("$destroy", function () {
                            carrierZoneDrawingService.cancelDrawing();
                            carrierZoneFreehandDrawingService.cancelDrawing();
                        });
                    }]
            };
        }]);
});